import script from "./CardIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardIcon.vue?vue&type=script&lang=ts&setup=true"

import "./CardIcon.vue?vue&type=style&index=0&id=553e56d2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-553e56d2"]])

export default __exports__